export default {
  get: function(){
    return {
      branch:{},
      achievement:{},
      formats:{},
      fetching: null,
      certified: null,
      error: null,
      certificate: {},
      certificates: []
    }
  }
}
